export const screenDestination = (destination: string) => destination === 'plans'
  ? { screen: 'Plans' }
  : { screen: 'Settings', params: { screen: destination === 'settings' ? 'SettingsHome' : 'AppScreen', ...(destination.startsWith('screen:') ? { params: { slug: destination.slice(7) } } : {}) } };
